import { PromotionTypeMapper } from "@omni/mappers/product/shared/enums/promotionType.enumMapper";
import { Promotion } from "@omni/types/api/product/bff/shared/promotion.model";
import { SalesIncentive } from "@omni/types/api/product/bff/shared/salesIncentive.model";
import { isDefined } from "@omni/utils/helper.utils";

import { safeParseISO } from "@/utils/date";

import { PromotionPeriodComponent } from "./promotionPeriod.component";

type PromotionPeriodProps = {
    salesIncentives: Array<SalesIncentive>;
    promotions: Array<Promotion>;
    className?: string;
};

const PromotionPeriod = ({
    salesIncentives,
    promotions,
    className
}: PromotionPeriodProps) => {
    const highestOrderSalesIncentiveType = salesIncentives
        .sort(
            (salesIncentive1, salesIncentive2) =>
                salesIncentive1.order - salesIncentive2.order
        )
        .at(0)?.type;

    const highestOrderPromotion = highestOrderSalesIncentiveType
        ? promotions.find(
              ({ promotionType }) =>
                  promotionType ===
                  PromotionTypeMapper.fromSalesIncentiveType(
                      highestOrderSalesIncentiveType
                  )
          )
        : undefined;

    const validFrom = safeParseISO(highestOrderPromotion?.validFrom);
    const validTo = safeParseISO(highestOrderPromotion?.validTo);

    if (!isDefined(validTo)) {
        return null;
    }

    return (
        <PromotionPeriodComponent
            className={className}
            validFrom={validFrom}
            validTo={validTo}
            periodText={highestOrderPromotion?.periodText || ""}
        />
    );
};

export { PromotionPeriod };
